<template>
  <div>
    <div v-if="viewForm">
      <h1
        v-bind:style="{ color: Company.CI_Headlinecolor }"
        class="mb-4"
        align="center"
      >{{LanguageStrings[DisplayLanguage]['headline_register']}}</h1>
      <p class="textcolor" v-if="this.Company.RegisterMode != 0">
        <input
          type="checkbox"
          id="email"
          onclick="return false;"
          :checked="new RegExp(/^[a-zA-Z0-9\.\-_]+@[a-zA-Z0-9\.\-_]+\.[a-zA-Z0-9\.]{2,}$/).exec((email+'').trim()) != null"
        />
        &nbsp;{{LanguageStrings[DisplayLanguage]['register_email']}}
      </p>
      <p class="textcolor" v-if="this.Company.RegisterMode != 0">
        <input
          type="checkbox"
          id="email2"
          onclick="return false;"
          :checked="(email+'').length > 0 && (email + '').trim() == (email2 + '').trim()"
        />
        &nbsp;{{LanguageStrings[DisplayLanguage]['register_emailmatch']}}
      </p>
      <p class="textcolor">
        <input
          type="checkbox"
          id="uppercase"
          onclick="return false;"
          :checked="new RegExp('[A-Z]').exec(password+'')"
        />
        &nbsp;{{LanguageStrings[DisplayLanguage]['register_uppercase']}}
      </p>
      <p class="textcolor">
        <input
          type="checkbox"
          id="lowercase"
          onclick="return false;"
          :checked="new RegExp('[a-z]').exec(password+'')"
        />
        &nbsp;{{LanguageStrings[DisplayLanguage]['register_lowercase']}}
      </p>
      <p class="textcolor">
        <input
          type="checkbox"
          id="number"
          onclick="return false;"
          :checked="new RegExp('[0-9]').exec(password+'')"
        />
        &nbsp;{{LanguageStrings[DisplayLanguage]['register_number']}}
      </p>
      <p class="textcolor">
        <input
          type="checkbox"
          id="minlen"
          onclick="return false;"
          :checked="(password+'').trim().length >= 8"
        />
        &nbsp;{{LanguageStrings[DisplayLanguage]['register_length']}}
      </p>
      <p class="textcolor">
        <input
          type="checkbox"
          id="pwequal"
          onclick="return false;"
          :checked="(password+'').trim().length > 0 && password+'' == password2+''"
        />
        &nbsp;{{LanguageStrings[DisplayLanguage]['register_pwmatch']}}
      </p>
      <p class="textcolor" v-if="this.GS.CredentialMode">
        <input
          type="checkbox"
          id="credential1check"
          onclick="return false;"
          :checked="(credential1+'').trim().length > 0"
        />
        &nbsp;{{LanguageStrings[DisplayLanguage]['register_credential1_check']}}
      </p>
      <p class="textcolor" v-if="this.GS.CredentialMode">
        <input
          type="checkbox"
          id="credential2check"
          onclick="return false;"
          :checked="(credential2+'').trim().length > 0"
        />
        &nbsp;{{LanguageStrings[DisplayLanguage]['register_credential2_check']}}
      </p>
      <form id="registerform" onsubmit="return false;" class="mt-4">
        <div class="form-group" v-show="Company.RegisterMode != 0">
          <label
            for="form_email"
            v-bind:style="{ color: Company.CI_Textcolor }"
          >{{LanguageStrings[DisplayLanguage]['username']}}</label>
          <input type="text" autocomplete="off" class="form-control" name="form_email" v-model="email" />
        </div>
        <div class="form-group" v-show="Company.RegisterMode != 0">
          <label
            for="form_email2"
            v-bind:style="{ color: Company.CI_Textcolor }"
          >{{LanguageStrings[DisplayLanguage]['username2']}}</label>
          <input type="text" autocomplete="off" onpaste="return false" class="form-control" name="form_email2" v-model="email2" />
        </div>
        <div class="form-group" v-show="Company.RegisterMode != 0 && !this.GS.CredentialMode">
          <label
            for="form_tan"
            v-bind:style="{ color: Company.CI_Textcolor }"
            translate="no"
          ><span>T</span><span>A</span><span>N</span></label>
          <input type="text" class="form-control" name="form_tan" v-model="GS.Tan" v-if="!this.GS.CredentialMode" />
          <input type="text" class="form-control" name="form_senderid" v-model="Company.SenderId" v-if="this.GS.CredentialMode" />
        </div>
        <div class="form-group">
          <label
            for="form_password"
            v-bind:style="{ color: Company.CI_Textcolor }"
          >{{LanguageStrings[DisplayLanguage]['password']}}</label>
          <input
            type="password"
            autocomplete="off"
            class="form-control"
            name="form_password"
            v-model="password"
          />
        </div>
        <div class="form-group">
          <label
            for="form_password2"
            v-bind:style="{ color: Company.CI_Textcolor }"
          >{{LanguageStrings[DisplayLanguage]['password2']}}</label>
          <input
            type="password"
            autocomplete="off"
            class="form-control"
            name="form_password2"
            v-model="password2"
            v-on:keyup.enter="register()"
          />
        </div>
        <div class="form-group" v-if="this.GS.CredentialMode">
          <label
            for="form_credential1"
            v-bind:style="{ color: Company.CI_Textcolor }"
          >{{LanguageStrings[DisplayLanguage]['register_credential1']}}</label>
          <input
            type="text"
            class="form-control"
            autocomplete="off"
            name="form_credential1"
            v-model="credential1"
          />
        </div>
        <div class="form-group" v-if="this.GS.CredentialMode">
          <label
            for="form_credential2"
            v-bind:style="{ color: Company.CI_Textcolor }"
          >{{LanguageStrings[DisplayLanguage]['register_credential2']}}</label>
          <input
            type="text"
            class="form-control"
            autocomplete="off"
            name="form_credential2"
            v-model="credential2"
            v-on:keyup.enter="registerByCredential()"
          />
        </div>
        <div>
          <input
            class="btn btn-success"
            type="button"
            :value="LanguageStrings[DisplayLanguage]['register']"
            :disabled="!canRegister"
            @click="register()"
            v-if="!this.GS.CredentialMode"
          />
          <input
            class="btn btn-success"
            type="button"
            :value="LanguageStrings[DisplayLanguage]['register']"
            :disabled="!canRegisterByCredential"
            @click="registerByCredential()"
            v-if="this.GS.CredentialMode"
          />
        </div>
        <input type="hidden" name="lang" :value="DisplayLanguage"/>
      </form>
    </div>
    <div v-if="showOK">
      <h1
        v-bind:style="{ color: Company.CI_Headlinecolor }"
        class="mb-0"
        align="center"
      >{{LanguageStrings[DisplayLanguage]['register_ok_mail']}}</h1>
    </div>
    <div v-if="showOKNoMail">
      <h1
        v-bind:style="{ color: Company.CI_Headlinecolor }"
        class="mb-0"
        align="center"
      >{{LanguageStrings[DisplayLanguage]['register_ok']}}</h1>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "RegisterDefault",
  components: {
    //HelloWorld
  },
  data: function() {
    return {
      viewForm: true,
      email: "",
      email2: "",
      password: "",
      password2: "",
      credential1: "",
      credential2: "",
      showOK: false,
      showOKNoMail: false,
    };
  },
  mounted: function() {
    if (this.Session != null && this.Session.Company.RegisterMode == 0) {
      this.email = (this.Session.To + '').trim();
      this.email2 = (this.Session.To + '').trim();
    }
    if(this.GS.PrefilledMail != null)
    {
      this.email = (this.GS.PrefilledMail + '').trim();
      this.email2 = (this.GS.PrefilledMail + '').trim();
    }
  },
  computed: {
    canRegister: function() {
      if ((this.GS.Tan + "").trim().length != 12) {
        return false;
      }
      if (
        new RegExp(
          /^[a-zA-Z0-9\.\-_]+@[a-zA-Z0-9\.\-_]+\.[a-zA-Z0-9\.]{2,}$/
        ).exec((this.email + "").trim()) == null
      ) {
        return false;
      }
      if (new RegExp("[A-Z]").exec(this.password + "") == null) {
        return false;
      }
      if (new RegExp("[a-z]").exec(this.password + "") == null) {
        return false;
      }
      if (new RegExp("[0-9]").exec(this.password + "") == null) {
        return false;
      }
      if ((this.password + "").trim().length < 8) {
        return false;
      }
      if (
        (this.password + "").trim().length == 0 ||
        this.password + "" != this.password2 + ""
      ) {
        return false;
      }
      if (this.email.trim() != (this.email2 + '').trim()) {
        return false;
      }
      return true;
    },
    canRegisterByCredential: function()
    {
      if (
        new RegExp(
          /^[a-zA-Z0-9\.\-_]+@[a-zA-Z0-9\.\-_]+\.[a-zA-Z0-9\.]{2,}$/
        ).exec((this.email + "").trim()) == null
      ) {
        return false;
      }
      if (new RegExp("[A-Z]").exec(this.password + "") == null) {
        return false;
      }
      if (new RegExp("[a-z]").exec(this.password + "") == null) {
        return false;
      }
      if (new RegExp("[0-9]").exec(this.password + "") == null) {
        return false;
      }
      if ((this.password + "").trim().length < 8) {
        return false;
      }
      if ((this.credential1 + "").trim().length == 0) {
        return false;
      }
      if ((this.credential2 + "").trim().length == 0) {
        return false;
      }
      if (this.email != (this.email2 + '').trim()) {
        return false;
      }
      if (
        (this.password + "").trim().length == 0 ||
        this.password + "" != this.password2 + ""
      ) {
        return false;
      }
      return true;
    },
  },
  methods: {
    register: function() {
      if (!this.canRegister || this.GS.CredentialMode) {
        return;
      }
      this.$parent.errortext = null;
      var self = this;
      axios
        .post(
          this.GS.Endpoint + "/v2/register/",
          this.form2JSON(document.getElementById("registerform")),
          {}
        )
        .then(function(response) {
          if(self.Session != null && self.Company.RegisterMode == 0)
          {
            self.GS.Session = response.data;
            self.$router.push("/read");
          }
          else
          {
            self.viewForm = false;
            self.showOK = true;
          }
        })
        .catch(function(response) {
          window.scrollTo(0,0);
          //console.log(response);
          if (response.response == undefined) {
            self.$parent.errortext = "internalservererror";
            return;
          }
          if (response.response.status == 410) {
            self.$parent.errortext = "sessionexpired";
            return;
          }
          if (response.response.status == 403) {
            self.$parent.errortext = "loginblocked";
            return;
          }
          if (response.response.status == 401) {
            self.$parent.errortext = "loginfailed";
            return;
          }
          if (response.response.status == 404) {
            self.$parent.errortext = "register_wrongtan";
            return;
          }
          if (response.response.status == 412) {
            self.$parent.errortext = "register_already_exists";
            return;
          }
          self.$parent.errortext = "internalservererror";
        });
    },
    registerByCredential: function() {
      if (!this.canRegisterByCredential) {
        return;
      }
      this.$parent.errortext = null;
      var self = this;
      axios
        .post(
          this.GS.Endpoint + "/v2/registerbycredential/",
          this.form2JSON(document.getElementById("registerform")),
          {}
        )
        .then(function(response) {
            self.viewForm = false;
            if(response.status == 201)
            {
              self.showOKNoMail = true;
            }
            else
            {
              self.showOK = true;
            }
        })
        .catch(function(response) {
          window.scrollTo(0,0);
          //console.log(response);
          if (response.response == undefined) {
            self.$parent.errortext = "internalservererror";
            return;
          }
          if (response.response.status == 410) {
            self.$parent.errortext = "sessionexpired";
            return;
          }
          if (response.response.status == 403) {
            self.$parent.errortext = "loginblocked";
            return;
          }
          if (response.response.status == 401) {
            self.$parent.errortext = "loginfailed";
            return;
          }
          if (response.response.status == 404) {
            self.$parent.errortext = "register_credentials_wrong";
            return;
          }
          if (response.response.status == 412) {
            self.$parent.errortext = "register_already_exists";
            return;
          }
          if (response.response.status == 417) {
            self.$parent.errortext = "register_credentialexists";
            return;
          }
          self.$parent.errortext = "internalservererror";
        });
    }
  }
};
</script>

<style scoped>
h1 {
  font-size: 20px;
}
h2 {
  font-size: 15px;
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 20px;
}
input {
  font-size: 13px;
}

p {
  margin-top: 5px;
  margin-bottom: 10px;
}
</style>
